import { handleClassNames } from "lib/cssHelpers";
import React from "react";
import styles from "@assets/css/home.module.css";
import { useRouter } from "next/router";
import FaqMapItem from "components/Home/FaqMapItem";
import { faq } from "lib/faq";
import Schemas from "../../../layouts/schema.json";
import { useState } from "react";
import { useEffect } from "react";
import Skeleton from "react-loading-skeleton";

const RepairFaq = ({ setLoader }) => {
  const router = useRouter();
  const [faqsList, setFaqList] = useState([]);
  const [show, setShow] = useState(true);
  const handleClasses = (classValue) => {
    return handleClassNames(classValue, styles);
  };

  const handleViewMore = () => {
    setLoader(true);
    router.push("/faq");
  };

  useEffect(() => {
    const CurrentPage =
      router?.query && router?.query?.slug?.length
        ? router?.query?.slug[1]
        : "";
    let category = "";
    if (typeof localStorage !== "undefined") {
      category = localStorage.getItem("selected-service");
    }
    const Data = Schemas;
    Data.FAQ?.map((item) => {
      if (item.page == category || item.page == CurrentPage) {
        setFaqList(item.Question);
      }
    });
  }, [router]);

  return (
    <section className={` ${handleClasses("faqs-section")}`}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className={`text-center ${handleClasses("title-anim")}`}>
              <div className={`header-all ${handleClasses("fqs-heade")} faq-color-all`}>
                Frequently Asked Questions (FAQs)
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div className={handleClasses("faqs-div")}>
              <div id="accordion" className={handleClasses("faqs-inner")}>
                {faqsList.length ? (
                  <>
                    {faqsList.slice(0, 6).map((item) => {
                      return <FaqMapItem item={item} show={show} setShow={setShow} />;
                    })}
                    <div
                      onClick={() => {
                        handleViewMore();
                      }}
                      class={handleClasses("view-more-faq")}
                    >
                      <a className="text-light">
                        View More <i class="fa-solid fa-arrow-right"></i>
                      </a>
                    </div>
                  </>
                ) : (
                  [null, null, null].map((item) => {
                    return (
                      <div className={handleClasses("faqs-inner-block")}>
                        <div
                          className={handleClasses("heading-txt-acc")}
                          id="headingOne"
                          data-toggle="collapse"
                          data-target="#pv1"
                          aria-expanded="true"
                          aria-controls="pv1"
                        >
                          <h5 className="mb-0">
                            <Skeleton
                              style={{
                                zIndex: 0,
                                background: "#ccc",
                                width: "100%",
                                height: "20px",
                                marginBottom: "10px",
                              }}
                            />
                          </h5>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RepairFaq;
